'use es6';

import { addPreProcessTransform, addPostProcessTransform } from '../utils/transformer';
import { isNaiveAnchorNode, isAnchorNode, isListTable } from '../utils/anchor';
import { ANCHOR_CLASSNAME, HS_ANCHOR_ATTRIBUTE, AnchorBlockSelectors } from '../constants/hsanchor';

// Anchor nodes need contenteditable=false in order to support drag & drop
export const addTransforms = editor => {
  addPreProcessTransform(editor, dom => {
    // Cannot query for HS_ANCHOR_ATTRIBUTE since older anchors won't have this attribute
    const anchorNodes = [...dom.body.querySelectorAll('a:not([href])')];
    const body = editor.getBody();
    anchorNodes.forEach(node => {
      if (isNaiveAnchorNode(node)) {
        node.setAttribute('id', node.id || node.name);
        node.setAttribute('contenteditable', 'false');
        node.setAttribute(HS_ANCHOR_ATTRIBUTE, true);
        if (!editor.settings.inline || editor.hasFocus()) {
          node.classList.add(ANCHOR_CLASSNAME);
        }
        if (editor.settings.allow_html_in_named_anchor && node.childNodes.length) {
          // https://github.com/tinymce/tinymce/blob/master/modules/tinymce/src/core/main/ts/html/ParserFilters.ts#L183
          // We want to override this core feature that we toggled true because we
          // don't want ACTUAL anchors to contain html (but we want to support
          // links with no [href] attr). So extract children from the anchor node.
          let sibling = node.lastChild;
          let prevSibling;
          while (sibling) {
            prevSibling = sibling.previousSibling;
            editor.dom.insertAfter(sibling, node);
            sibling = prevSibling;
          }
        }
        let invalidParentBlock = node;
        Object.keys(AnchorBlockSelectors).forEach(tier => {
          invalidParentBlock = editor.dom.getParent(invalidParentBlock, AnchorBlockSelectors[tier], body) || invalidParentBlock;
        });
        const listTable = isListTable(node);
        if (listTable) invalidParentBlock = listTable;
        if (node !== invalidParentBlock) {
          node.parentNode.removeChild(node);
          invalidParentBlock.parentNode.insertBefore(node, invalidParentBlock);
        }
      }
    });
  });
  addPostProcessTransform(editor, dom => {
    const anchorNodes = [...dom.querySelectorAll(`a[${HS_ANCHOR_ATTRIBUTE}]`)];
    anchorNodes.forEach(node => {
      if (isAnchorNode(node)) {
        node.removeAttribute('contenteditable');
        node.classList.remove(ANCHOR_CLASSNAME);
        if (node.className === '') {
          node.removeAttribute('class');
        }
      }
    });
  });
};